/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Chinese(Chinese - Simplified) language
 *
 * @file zh-cn.js
 * @author Manimaran.S
 */

const zhcn = {
  'popularChannelSlider.allChannels': '所有频道',
  'popularChannelSlider.recommended': '推荐',
  'hero.myetextbook.link': '库',
  'hero.myetextbook.text': '书名不对？访问您的电子教材',
  'hero.etextfeaturestitle': '在您的电子教材中查找学习资料',
  'hero.etextfeaturesdescription': '您的电子教材附带了旨在助您成功掌握知识的学习资料。在您的电子教材中使用闪卡等工具学习。',
  'aichat.title1': '获取与这本电子教材相关的人工智能辅助帮助。',
  'aichat.chatDesc1': '输入问题开始',
  'subscriptiontext.isSubscribed': '您订阅的部分内容',
  'subscriptiontext.nonSubscriber': '升级以获得完整访问权限',
  'topicConatiner.otherHeader': '相关视频与练习',
  'topicConatiner.exactLiteHeader': '相关概念与练习',
  'moremenu.downloadApp': '下载应用',
  'moremenu.downloadAppAlreadyDownload': '%Click here% 将应用程序下载到其他设备上并自动登录，或使用您唯一的二维码安全登录您已安装的应用程序。',
  'moremenu.downloadAppNotDownload': '%Click here% 下载应用程序并使用您唯一的二维码安全登录',
  'channel.noBundletitle': '使用学习准备来学习您的相关课程和其他课程',
  'onboard.studyPlan': '已创建自定义学习计划！',
  'onboard.addCourseAnother': '您是否想添加其他课程？',
  'onboard.purchase': '我需要购买培生电子教材',
  'onboard.addCourseWithoutEtext': '使用学习准备添加课程',
  'onboard.mayBeLater': '稍后',
  'onboard.aboutCourse': '告诉我们您的课程',
  'onboard.close': '关闭',
  'course.addTitle': '添加课程',
  'common.PURCHASE': '购买',
  'common.CLOSE': '关闭',
  'open': '打开',
  'continue': '继续',
  'yes': '是',
  'no': '否',
  'audio': '音频',
  'courses.toc.PUBLISH_SUCCESS': '成功！',
  'courses.toc.PUBLISH_MESSAGE': '学生将在下次打开内容时看到您的更改。',
  'errors.GENERIC_TITLE': '您当前无访问权限',
  'errors.GENERIC_DESC': '请先刷新或清除缓存。若无效，请联系培生 ',
  'errors.GENERIC_LINK': '客服。',
  'errors.GENERIC_CODE': '错误代码：{code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': '订阅未找到',
  'errors.SUBSCRIPTION_GENERIC_DESC': '您的账户没有访问该章目的权限。如果您认为您错误接收了这条消息，请联系培生技术支持团队',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': '订阅未找到',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': '您的订阅不包括访问 eText，然而您可以选择使用信用卡立即订阅。',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': '我的帐户',
  'menu.helpCenter': '帮助中心',
  'menu.preferencesCenter': '偏好设置中心',
  'menu.CONTACT_SUPPORT': '联系客服团队',
  'menu.HELP_SUPPORT': '帮助和支持',
  'menu.FAQS': '常见问题',
  'menu.CHAT_WITH_SUPPORT': '与客服交谈',
  'menu.OTP_CODES': 'OTP 代码',
  'menu.LAUNCH_CODE': '启动代码日志',
  'menu.SEND_CODE': '通过电子邮件向用户发送新代码',
  'menu.SEND_CODE_PHONE': '通过短信向用户发送新代码',
  'menu.LEGAL': '法务部',
  'menu.PRIVACY_NOTICE': '隐私通知',
  'menu.TITLE_INFO': '标题信息',
  'menu.PEARSON_ACCESSIBILITY': '培生可及性',
  'menu.DEVICE_WARNING_MESSAGE': '注册 {deviceLimit} 台设备。每月可切换1台设备。',
  'menu.ACCESSIBILITY': '可及性',
  'menu.ACCESSIBILITY_SUPPORT': '可及性支持',
  'menu.DEVICES': '最近设备',
  'menu.THIS_DEVICE': '此设备',
  'menu.GET_THE_APP_DOWNLOAD': '下载移动应用程序',
  'menu.MOJO_APP_INFO': '前往您的手机或平板上的应用程序商店以离线使用Pearson+。',
  'menu.DEVICE_LABEL': '设备',
  'menu.DEVICE_DISCONNECT': '断开',
  'menu.FOXIT': 'Foxit 提供支持',
  'menu.TERMS_OF_USE': '使用条款',
  'menu.SIGN_OUT': '注销',
  'menu.PRINT_PAGE': '打印页面',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. 保留所有权利。',
  'print.FOOTER_MESSAGE': '出版机构为{fullName}({email})，出版日期为{currentDate}。',
  'print.WATERMARK': '版权所有© {year} Pearson Education',
  'device.SWAPPED_ALREADY': '您本月已经切换过了',
  'device.SWITCH_DEVICE': '切换到当前设备？',
  'device.SWITCH_ONCE': '由于您每月只能进行一次切换，因此您无法撤销此操作。',
  'device.SEAT_TAKEN': '该名额已被占用',
  'device.DISCONNECT_DEVICE': '您只能在3台设备上登录。要从此处继续，请断开另一台设备。',
  'device.ALERT_TEXT': '请记住，您每月只能进行一次设备切换。',
  'device.DISCONNECT': '断开',
  'device.CONTINUE': '继续',
  'device.HEADER': '结束您的其他浏览器会话？',
  'device.CLOSE': '回到主页',
  'device.CODE': '请输入发送至{maskedEmail}的验证码，继续操作。无法验证？请检查垃圾邮件文件夹、{email}，或联系{support}。',
  'device.TIMER': '您需要在此处{time}输入验证码',
  'device.RESEND': '{resend}',
  'device.FAQ': '常见问题',
  'device.RESEND_NAME': '重新发送',
  'device.NOTE': '若您常在2处使用Pearson+（如办公、居家），使用完毕请退出登录。Pearson+移动应用最多可在2台设备上使用。更多信息，请参阅我们的{faq}。',
  'device.NOTE_HEADER': '避免再次出现此问题',
  'device.CONTACT_SUPPORT': '客户支持',
  'device.CONTACT_EMAIL': '更新您的电子邮件',
  'device.INCORRECT': '验证码错误 - 请检查验证码输入是否正确，再试一次。',
  'device.MANY_ATTEMPTS': '错误次数过多，请重新发送验证码',
  'device.EXPIRED': '验证码已过期，请重新发送验证码',
  'device.ACCESS_HEADER': '大功告成！',
  'device.ACCESS_DESC': '您的会话已通过验证。想要在登录状态下更改密码？',
  'device.ACCESS_CHANGE_PASSWORD': '更改密码',
  'device.ACCESS_RESET_PASSWORD': '重置密码',
  'device.THREATONE_TITLE': '是否一切正常？',
  'device.THREATONE_DESC': '我们注意到您的帐户存在可疑活动。',
  'device.THREATONE_DESC_TWO': '建议您最好修改密码。',
  'device.MAY_BE_LATER': '稍后',
  'device.OKAY': '确定',
  'device.ACCOUNT_LOCK_DESC': '为了安全起见，我们将使您先注销。我们已向您的帐户关联电子邮箱发送了密码重置链接。',
  'device.ACCOUNT_LOCK_TITLE': '我们注意到您的帐户存在一些可疑活动',
  'device.ACCOUNT_LOCK_TIMER': '您將被登出 {time}',
  'navigation.PAGE': '页码',
  'launchcode.CREATEBY': '创建于：',
  'launchcode.sentvia': '发送方式:',
  'launchcode.CODEINLAST': '过去 7 天内的代码：',
  'launchcode.TIMESENT': '发送时间：',
  'launchcode.ACCOUNTEMAIL': '帐户电子邮箱：',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP 代码日志',
  'textmessage.TITLE': '输入电话号码',
  'textmessage.PHONE_NUMBER': '电话号码',
  'textmessage.SEND_CODE': '发送代码',
  'textmessage.INVALID_NUMBER': '无效的电话号码。',
  'textmessage.SUCCESS_MESSAGE': '代码已发送',
  'remove.title': '误删了书目？',
  'remove.subTitle': '您可随时恢复误删书目——重新搜索后再次添加即可。',
  'remove.buttonText': '删除',
  'search.searchPlaceHolderPPlus': '按ISBN、标题或作者搜索',
  'search.searchPlaceHolderEText': '搜索您的资料库',
  'footer.downloadMobileApp': '下载移动应用程序',
  'footer.termsOfUse': '使用条款',
  'footer.privacy': '隐私',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': '不要出售我的个人信息',
  'footer.accessibility': '可及性',
  'footer.patentNotice': '专利通知',
  'footer.copyrights': '培生保留所有权利。',
  'hero.toc.defaultPlacehoder': '--- 选择主题 ---',
  'hero.openEtextBookV1': '打开电子教材',
  'hero.heroHeading': '因为您正在学习 <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': '学习准备',
  'hero.study.help': '获得学习帮助',
  'hero.study.jumpBackIn': '返回',
  'hero.study.numOfUsers': '当前有<b>{num_of_users}</b>名学生正在使用频道功能。',
  'hero.heroChannel.cardsHeading': '从中断处继续',
  'hero.marketingcard1.copy.title': '利用视频学习',
  'hero.marketingcard1.copy.description': '观看分析讲解复杂话题的简短视频。',
  'hero.marketingcard2.copy.title': '习题',
  'hero.marketingcard2.copy.description': '利用海量的模拟习题和讲解视频解决方案，为考试做好准备',
  'hero.marketingcard3.copy.title': '向经验丰富的人士获取帮助',
  'hero.marketingcard3.copy.description': '发布问题，并从课程专家处获得解答。',
  'hero.popularTopics.heading': '本频道的其他热门话题',
  'hero.popularChannels.headingv1': '参加另一门课程？',
  'hero.popularChannels.descriptionv2': '浏览热门学习帮助主题。',
  'hero.practice': '练习',
  'hero.herobook.mappedChannelHeading': '本频道推荐的学习帮助',
  'libraryL2.myBooks': '我的图书',
  'libraryL2.archived': '已存档',
  'libraryL2.back': '返回',
  'hero.practiceProblem': '练习题',
  'nativeAppBanner.drawer.title': '在……中打开',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+应用',
  'nativeAppBanner.banner.title': 'Pearson+应用',
  'nativeAppBanner.banner.description': '随时随地学习',
  'hero.promotionalcard.list1': '分析讲解复杂话题的简短视频',
  'hero.promotionalcard.list2': '海量的模拟习题',
  'hero.promotionalcard.list3': '从课程专家处获得解答',
  'hero.studyandexamprep': '学习准备',
  'hero.heroBook.sectionSubHeadingV1': '通过专为您的课程量身打造的视频讲解和练习题，条分缕析艰深主题。',
  'hero.heroBook.sectionSubHeadingV2': '通过专为您的课程量身打造的概念讲解和练习题，条分缕析艰深主题。',
  'hero.SeeAllStudyOptions': '查看全部学习选项',
  'hero.herobook.mappedChannelHeadingV1': '推荐视频与练习题',
  'hero.popularTopics.headingV1': '其他热门话题',
  'hero.heroHeadingV1': '包含<span>{replace_value}</span>',
  'hero.learnmore': '了解更多内容',
  'hero.eTextbook': '电子教材',
  'hero.goToPage.label': '转到页面',
  'subscription.studyTitle': '学习准备',
  'print.printAvailTitle': '想要打印此页吗？以下是操作方法',
  'print.printAvailDesc': '在您的电子教材中，选择右上角的帐户图标。从选项中选择“打印页面”，然后选择打印设置。',
  'print.printNotAvailTitle': '本电子教材未启用打印功能。',
  'print.printNotAvailDesc': '为方便离线阅读，请通过Pearson+移动应用下载电子书，随时随地灵活学习！',
  'hero.header.cta': '前往学习工具',
  'hero.header.ctav2': '打开学习准备',
  'hero.marketing.title': '查找您的电子教材',
  'hero.marketing.subTitle': '从2,000多套电子教材中选择，内容涵盖音频、记忆卡、笔记等。每学期时长4个月，每月仅收取$10.99。',
  'hero.popularchannels.desc': '在这些热门科目中获得学习帮助',
  'hero.removecourse.title': '从控制面板中删除课程？',
  'hero.removecourse.description': '您随时可以通过点击“Add course（添加课程）”重新将这个课程添加到控制面板中',
  'hero.removecourse.primaryCtaText': '删除',
  'hero.removecourse.secondaryCtaText': '取消',
  'hero.tableOfContents': '目录',
  'hero.search': '搜索',
  'hero.emptystate.cta': '搜索电子教材',
  'hero.watch_it_again': '再次观看',
  'hero.mondly.learnLang.title': '免费学习一种新语言',
  'hero.mondly.subTitle': '培生电子教材用户可免费获得三个月的Mondly by Pearson。',
  'hero.mondly.description': '大多数语言学习应用程序只允许您通过英语学习其他语种。但最佳方式是通过您的母语学习其他语种，因此，在Mondly中，您可以通过我们 41 种语言中的任何一种学习其他语种。',
  'hero.mondly.startLearningCTA': '开始学习',
  'hero.mondly.marketing.bestApp': '最佳应用',
  'hero.mondly.marketing.appStore': '苹果应用商店',
  'hero.mondly.marketing.appYear': '年度应用',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017年EMEA获奖作品',
  'hero.mondly.marketing.editorChoice': '编辑精选',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': '学习一种语言',
  'header.menu.moreAtPearson': '培生的更多内容',
  'hero.subscriptionStatusTitle2': '您的Pearson+资源',
  'hero.startStudying': '开始学习',
  'onboard.studyMaterials': '选择您的课程，我们将创建一个包含自定义学习材料的控制面板。',
  'hero.myETextbooks': '我的电子教材',
  'header.continueInTheApp': '在应用程序中继续',
  'hero.learnTxt': '学习',
  'hero.examPrepTxt': '考试准备',
  'hero.aITutorTxt': '人工智能导师',
  'AI.toolTip': '就您的电子教材中的任何内容向我提问',
  'hero.studyExamPrepAllYourCourses': '适用于您所有课程的学习准备',
  'header.qrCode.subHeaderTxt': '使用此二维码快速安全地登录移动设备上的Pearson+应用程序。',
  'header.qrCode.dontHaveApp': '没有该应用程序？',
  'header.qrCode.footerTxt': '扫描此二维码会将您重定向到App Store或Google Play。下载该应用程序后，再次扫描登录。',
  'header.qrCode.errorMsg': '二维码无法加载。关闭并重试。',
  'hero.yourETextbook': '您的电子教材',
  'onboard.addCourseWithEtextBundle': '使用学习准备添加课程',
  'onboard.disableTooltipText': '所有学习准备课程均已添加！',
  'subscriptionstatus.bundlecta': '访问学习准备',
  'subscriptionstatus.nonbundlecta': '访问学习准备',
  'channel.genericBundle': '利用学习准备帮助您学习其他课程',
  'channel.relatedBundle': '还可利用学习准备帮助您学习其他课程',
  'onboard.courseAdded': '已添加课程！',
  'hero.flashcards': '记忆卡',
  'relatedChannelCard.title': '利用此相关资源提升你的学习体验',
  'relatedChannelCard.badgeText': '相关学习准备',
  'sessionInactivity.title': '你还在吗？',
  'sessionInactivity.description': '由于长时间未操作，您的会话将在<b>%TIMER%</b>后超时。<br/>是否要保持登录状态？',
  'sessionInactivity.keepMeSignIn': '让我保持登录状态',
  'sessionInactivity.signOut': '注销',
  'sessionTimeout.title': '会话超时',
  'sessionTimeout.description': '由于处于非活动状态，您的会话已超时。',
  'print.qrCode.header': '使用此二维码可打开移动设备上的Pearson+应用程序。',
  'print.qrCode.footer': '扫描此二维码会将您重定向到App Store或Google Play。安装该应用程序后，登录以下载并访问您的书籍。',
  'hero.nestest.title': '备战教师资格考试',
  'hero.nestest.subTitle': 'Pearson+用户现已可使用符合国家统一标准的备考课程与模拟测试，备战教师资格考试。',
  'hero.channelAI.title': '需要帮助吗？AI导师为您提供帮助。',
  'hero.channelAI.desc': '随时提出一个问题，您便会获得逐步的作业帮助、学习建议等个性化帮助。',
  'hero.channelAI.action': '现在请教AI导师',
  'new': '新！',
  'hero.practice.numOfUsers': '本部分包含<b>{practice_num_of_users}</b>道练习题。',
  'hero.practice.cta': '立即练习',
  'hero.practice.title': '练习题',
  'diagnostics.errorMsg': '诊断功能未加载。关闭并重试',
  'qrcode.title': '随时随地开始学习',
  'qrcode.subtitle': '使用Pearson+移动应用，随时随地学习。立即下载，开启无缝学习体验。',
  'qrcode.detailsv1': '使用Pearson+应用扫描此二维码，即可从中断处继续。随时随地搜索书中的内容、通过抽认卡学习、观看视频课程等。',
  'qrcode.detailsv2': '随时扫描此二维码，即可快速登录并从中断处继续学习。',
  'qrcode.details': '使用Pearson+应用扫描此二维码，即可从中断处继续。',
  'qrcode.appstore': '苹果应用商店',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': '使用Pearson+移动应用，随时随地学习。立即下载，开启无缝学习体验。',
  'install': 'Install',
  'header.menu.createCourse': '新建课程',
  'header.dropdown.courses': '课程',
  'header.dropdown.recentlyViewed': '最近查看',
  'header.dropdown.viewAll': '查看全部课程',
  'aet.courseHeader.inviteStudents': '邀请学生',
  'aet.courseHeader.inviteStudentModal.subTitle': '复制下方链接或说明至电子邮件或教学大纲，邀请学生访问本电子教材。',
  'aet.courseHeader.inviteStudentModal.linkAddress': '链接地址',
  'aet.courseHeader.inviteStudentModal.copyLink': '复制链接',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': '含链接地址的说明',
  'aet.courseHeader.inviteStudentModal.copyInstructions': '复制说明',
  'aet.courseHeader.inviteStudentModal.instructionIntro': '现已可访问{bookTitle}，{courseName}配套电子教材。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': '准备就绪后，可通过以下地址访问您的电子教材：{enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': '系统将提示您使用现有培生账户登录。若无培生账户，可自行注册。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': '需要帮助吗？',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': '开始日期：',
  'aet.courseHeader.endDate': '结束日期：',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': '格式：',
  'aet.home.manageroster': '管理名册',
  'aet.home.managegradesync': '管理成绩同步',
  'aet.home.copycourse': '复制课程',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': '当前',
  'aet.instructorCourse.tabs.past': '过去',
  'aet.instructorCourse.tabs.courseSettings': '课程设置',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': '管理名册',
  'aet.instructorCourse.currentCourses.title': '当前课程',
  'aet.instructorCourse.pastCourses.title': '往期课程',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': '创建或复制培生电子教材课程',
  'aet.instructorCourse.createOrCopy.sectionTitle': '复制其他教师课程，或创建新课程',
  'aet.instructorCourse.createOrCopy.copyPanel.title': '复制其他教师课程',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': '输入课程ID，查找需复制的课程。',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': '课程ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': '输入课程ID',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': '您搜索的内容',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': '从课程目录创建新课程',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': '按书名、作者、ISBN或主题关键词搜索。',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': '搜索中……',
  'aet.instructorCourse.createOrCopy.showMoreLabel': '显示更多内容',
  'aet.instructorCourse.createOrCopy.showLessLabel': '显示更少内容',
  'aet.instructorCourse.cancel': '取消',
  'aet.instructorCourse.loading': '加载中……',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': '成绩同步',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': '管理成绩同步',
  'aet.instructorCourse.courseForm.courseNameLabel': '课程名称',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': '无标题',
  'aet.instructorCourse.courseForm.sectionNameLabel': '班级名称',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': '无标题',
  'aet.instructorCourse.courseForm.institutionFieldLabel': '所属院校',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': '院校为必填项',
  'aet.instructorCourse.courseForm.institutionSearchError': '出错了。请重试。',
  'aet.instructorCourse.courseForm.institutionNoResults': '未找到结果',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': '课程开始日期',
  'aet.instructorCourse.courseForm.endDateLabel': '课程结束日期',
  'aet.instructorCourse.courseForm.datePlaceholder': '日/月/年',
  'aet.instructorCourse.courseForm.allowCopyLabel': '允许他人复制本课程',
  'aet.instructorCourse.courseForm.shareCodeLabel': '将此代码分享给需复制本课程的教师',
  'aet.instructorCourse.courseForm.copyCodeLabel': '复制代码',
  'aet.instructorCourse.courseForm.optionalSuffix': '（选填）',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': '表单存在验证错误',
  'aet.instructorCourse.courseForm.submitContinue': '继续',
  'aet.instructorCourse.courseForm.submitContinueLoading': '保存中……',
  'aet.instructorCourse.courseForm.submitError': '无法创建您的课程。请重试。',
  'aet.instructorCourse.courseForm.submitEditError': '无法保存您的更改。请重试。',
  'aet.instructorCourse.courseForm.submitSaveChanges': '保存更改',
  'aet.instructorCourse.courseForm.materialsHeader': '课程材料',
  'aet.instructorCourse.courseForm.resolveError': '无法加载课程资料。请重试。',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': '最后查看',
  'aet.instructorCourse.coursesSort.recentlyAdded': '最近添加',
  'aet.instructorCourse.coursesSort.aToZ': 'A到Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z到A',
  'aet.instructorCourse.manageRoster.column.name': '姓名',
  'aet.instructorCourse.manageRoster.column.role': '职责',
  'aet.instructorCourse.manageRoster.column.email': '电子邮件',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': '状态',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': '学生',
  'aet.instructorCourse.roster.role.ta': '助教',
  'aet.instructorCourse.roster.role.instructor': '教师',
  'aet.instructorCourse.roster.status.active': '有效',
  'aet.instructorCourse.roster.status.inactive': '禁用',
  'aet.instructorCourse.manageRoster.filter.allMembers': '全部成员',
  'aet.instructorCourse.manageRoster.filter.activeStudents': '在读学生',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': '非在读学生',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': '助教',
  'aet.instructorCourse.manageRoster.filter.instructor': '教师',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': '作者：',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN：',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': '课程创建日期：',
  'aet.instructorCourse.noCoursesFound': '未找到课程',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': '返回',
  'aet.instructorCourse.selectCourse': '选择课程',
  'aet.home.linkedToLms': '已关联LMS',
  'aet.instructorCourse.courseForm.title.create': '创建课程',
  'aet.instructorCourse.courseForm.title.copy': '复制课程',
  'aet.instructorCourse.courseForm.title.edit': '课程信息',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': '设置',
  'aet.studentRoster.manageStudentRosterButton': '管理学生名册',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': '导出学生学习进度',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': '状态：',
  'aet.home.student.roaster.enrolmentInformation.enrolled': '选课状态：',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': '角色：',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '是否晋升为{studentName}？',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': '担任助教后，该用户可查看本班所有学生的学习进度与表现。',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': '助教还可管理学生与作业，但无权删除班级。',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': '晋升为助教',
  'aet.home.manageRoster.searchPlaceholder': '搜索学生',
  'aet.home.manageRoster.inactivateButtonLabel': '停用所选学生账号',
  'aet.home.manageRoster.FilterLabel': '显示',
  'aet.home.manageRoster.updatingMessage': '正在更新名册……可能需要几分钟时间。',
  'aet.home.courses.search.searchPlaceHolder': '搜索您的课程',
  'aet.courses.emptyStateDescription': '选择下方选项，开始创建您的课程。',
  'nativePromoBanner.continueInBrowser': '在浏览器中继续',
  'globalnav.tooltip.hideNavText': '隐藏导航栏',
  'globalnav.tooltip.showNavText': '显示导航栏',
  'aet.syllabus.progressTitle': '提取中……',
  'aet.syllabus.progressDesc': '我们正在处理您的教学大纲，请稍候。',
  'aet.syllabus.uploadInputLabel': '拖放文件或单击上传',
  'aet.syllabus.uploadSyllabusTabLabel': '上传教学大纲',
  'aet.syllabus.dateAdjusterTabLabel': '日期调整工具',
  'aet.syllabus.addManuallyTabLabel': '手动添加作业',
  'aet.syllabus.addEditLaterText': '后续可随时添加和编辑作业',
  'aet.syllabus.editAssignmentLabel': '编辑作业',
  'aet.syllabus.addAssignmentLabel': '添加作业',
  'aet.syllabus.assignmentTitleLabel': '作业标题',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': '截止日期',
  'aet.syllabus.editDueDateLabel': '编辑截止日期',
  'aet.syllabus.chaptersCoveredLabel': '选择要涵盖的章节或小节。',
  'aet.syllabus.updateCtaLabel': '更新作业',
  'aet.syllabus.addCtaLabel': '添加作业',
  'aet.syllabus.uploadLabel': '上传',
  'aet.syllabus.confirmLabel': '确认',
  'aet.syllabus.addContentLabel': '添加内容',
  'aet.syllabus.addEditContentLabel': '添加/编辑内容',
  'aet.syllabus.notPublishedLabel': '未发布',
  'aet.syllabus.updateDatesLabel': '更新日期',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': '您的截止日期已更新。核对后发布。',
  'aet.syllabus.coverageDedupe.adjustedContent': '您的章节/小节信息已更新。核对后发布。',
  'aet.syllabus.unassignedCoverageStatus': '部分章节尚未布置作业。请在发布前完成布置。',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': '删除作业？',
  'aet.deleteAssignmentTitleMultiple': '删除作业？',
  'aet.deleteAssignmentWarning': '此操作不可撤销，所有相关提交记录和学生数据将不再可见。',
  'aet.deleteAssignmentKeepCTA': '保留作业',
  'aet.deleteAssignmentDeleteCTA': '删除',
  'aet.assignments.loadingAsset': '资源加载中……',
  'aet.assignments.addToDate': '添加至日期',
  'aet.assignments.previewAsStudent': '以学生身份预览',
  'aet.assignments.questionsAndTopics': '题目与主题',
  'aet.assignments.questionsAndTopicsModal.doneLabel': '完成',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': '截止日期',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': '题目总数',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': '问题{count}/ {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': '向学生发布',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': '添加日期',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': '完成',
  'aet.assignments.dueDateLabel': '作业截止日期',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': '手动设置',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': '借助实时数据发现学习薄弱点，便于您及早针对性调整教学',
  'aet.onboarding.promotion.feature.3': '借助针对性反馈与内置培生AI，为学生提供更多学习支持',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': '本周无待完成作业。',
  'aet.assignments.progressTitle': '进度',
  'aet.assignments.performanceTitle': '掌握程度',
  'aet.assignments.completionTitle': '完成情况',
  'aet.assignments.statusTitle': '状态',
  'aet.assignments.addTooltip': '添加作业',
  'aet.assignments.deleteTooltip': '删除选中的作业',
  'aet.assignments.selectToDeleteLabel': '选择并删除模式',
  'aet.assignments.bulkEditTooltip': '批量编辑作业',
  'aet.assignments.title': '作业',
  'aet.assignments.assignmentTitle': '作业',
  'aet.assignments.dueDate': '截止日期',
  'aet.tabular.searchPlaceholder.assignments': '搜索作业',
  'aet.tabular.searchPlaceholder.students': '搜索学生',
  'aet.tabular.searchPlaceholder.questions': '搜索题目',
  'aet.assignemnts.columnDueDateInfoTooltip': '一名或多名学生的全部作业已延长截止日期',
  'aet.assignemnts.singleDueDateInfoTooltip': '一名或多名学生的本次作业已延长截止日期',
  'aet.assignemnts.masterDueDateInfoTooltip': '已为一名或多名学生延长作业截止日期。查看信息图标以识别此类作业。',
  'aet.home.loading': '加载中……',
  'aet.home.errorFetchingAssignments': '获取作业时出错',
  'aet.home.dueThisWeekTitle': '本周待完成',
  'aet.home.allCaughtUpTitle': '您已全部跟上进度！',
  'aet.home.allCaughtUpDescription': '本周无待完成作业。',
  'aet.home.suggestedRemediationTitle': 'Study Prep推荐复习内容',
  'aet.home.noSuggestedRemediationTitle': '无建议复习材料',
  'aet.home.noSuggestedRemediationDescription': '完成下一次作业后再来查看。',
  'aet.home.assignmentIncludesTitle': '作业包含',
  'aet.home.sectionsLabel': '章节',
  'aet.home.questionsCount': '{count} 题目',
  'aet.home.dueLabel': '截止日期：{dueDate}',
  'aet.home.due': '截止日期：',
  'aet.home.progressCompletedLabel': '已完成',
  'aet.home.progressCompletedPastDueLabel': '逾期作业已完成',
  'aet.home.progressInProgressLabel': '正在进行',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': '未开始',
  'aet.home.progressCountOfTotal': '{count} / {total}',
  'aet.home.NotAttemptedLabel': '未尝试',
  'aet.home.questionsTotalLabel': '问题总数',
  'aet.home.progressCompletedOnTimeLabel': '按时完成',
  'aet.home.segmentGreatLabel': '表现出色',
  'aet.home.segmentGettingThereLabel': '确定',
  'aet.home.segmentNeedsReviewLabel': '需要改进',
  'aet.home.segmentOkayLabel': '确定',
  'aet.home.editAssignmentTooltip': '编辑作业',
  'aet.home.deleteAssignmentTooltip': '删除作业',
  'aet.home.viewDetailsButton': '查看详情',
  'aet.home.viewAsStudentButton': '以学生身份查看',
  'aet.home.welcomeButtonText': '开始 →',
  'aet.review.emptyStateTitle': '无复习内容',
  'aet.review.emptyStateDescription': '完成下一次作业后再来查看。',
  'aet.dashboard.tabs.upNext': '下一个',
  'aet.dashboard.tabs.welcome': '欢迎',
  'aet.dashboard.tabs.assignments': '作业',
  'aet.dashboard.tabs.review': '复习',
  'aet.dashboard.tabs.studentRoster': '学生',
  'aet.dashboard.classSchedule': '课程表:',
  'aet.syllabus.dueTimeLabel': '截止时间',
  'hero.accessEducatorGuides': '访问教育者指导手册',
  'aet.assignment.save': '保存',
  'aet.assignment.finish': '完成',
  'aet.assignment.saveAndAdd': '保存并添加另一个',
  'aet.assignment.delete': '删除',
  'aet.assignment.saveAndClose': '保存并关闭',
  'aet.studentRoster.title': '学生',
  'aet.studentRoster.titlev1': '学生',
  'aet.studentRoster.dueDatesAdjustmentLabel': '截止日期',
  'aet.studentRoster.dueDateAdjustment.option.0': '标准',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2天',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3天',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5天',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1周',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2周',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': '课程最后一天',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': '我们将为您平均分配作业任务。',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer.Editor library device auto star reesizing pencil horizontal.Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': '首次作业截止时间',
  'aet.bulkEdit.lastAssignmentDue': '末次作业截止时间',
  'aet.bulkEdit.assignmentsDueDays': '您希望将作业截止日设置在星期几？',
  'aet.bulkEdit.addEditLaterText': '我们使用AI生成作业。您后续可随时添加和编辑作业。',
  'aet.bulkEdit.monday': '星期一',
  'aet.bulkEdit.tuesday': '星期二',
  'aet.bulkEdit.wednesday': '星期三',
  'aet.bulkEdit.thursday': '星期四',
  'aet.bulkEdit.friday': '星期五',
  'aet.bulkEdit.saturday': '星期六',
  'aet.bulkEdit.sunday': '星期天',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': '更新成功。',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '{count}份作业已更新',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': '在学生开始作答前，均可编辑作业内容。',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': '查看作业',
  'aet.toast.viewAssignments': '查看作业',
  'aet.welcome.title': '您的培生电子教材现已关联至您的LMS课程',
  'aet.welcome.LMSAccounTitle': '探索学情洞察',
  'aet.welcome.LMSAccounDescription': '精准掌握您的班级的薄弱知识点。',
  'aet.welcome.createAssignmentsTitle': '创建作业',
  'aet.welcome.createAssignmentsDescription': '手动或通过上传教学大纲分配章节。',
  'aet.welcome.progressViewTitle': '在您的LMS中追踪成绩',
  'aet.welcome.progressViewDescription': '在您的LMS课程中选择成绩同步设置。',
  'aet.assignmentDetails.noAssignmentFound': '未找到作业',
  'aet.assignments.loadingErrorTitle': '作业目前无法加载',
  'aet.assignments.loadingErrorDescription': '请尝试刷新或稍后再来查看。',
  'aet.assignmentStudentDetails.noDataFound': '暂无数据',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': '暂无学生注册',
  'aet.studentRoster.noStudentsRegisteredYetDescription': '学生购买电子教材后将加入您的班级。',
  'aet.home.editAssignmentTooltipDisabled': '无法编辑：学生正在作答中',
  'aet.home.deleteAssignmentTooltipDisabled': '无法删除：学生正在作答中',
  'aet.home.StudentDetails.questions': '问题',
  'aet.home.StudentDetails.attempts': '尝试次数',
  'aet.home.StudentDetails.comprehension': '掌握程度',
  'hero.titleInfo.tooltip': '书本信息',
  'aet.home.publishAssignments': '发布全部作业',
  'aet.assignments.saveScheduleAsDraft': '将排期保存为草稿',
  'aet.assignments.reviewBeforePublishAlert': '核对作业内容后发布，学生即可查看。',
  'aet.assignments.copiedCoursePublishAlert': '为复制的作业添加日期，发布后学生即可查看。',
  'aet.assignments.allSetPublishAlert': '都设置好了？发布作业后，学生即可查看。',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': '基于培生学习材料使用AI创建的一些内容。尽管培生有一个验证结果的流程，但生成式AI仍可能产生关于人员、地点或事实的不准确信息。',
  'aet.home.bulkEditTitle': '批量编辑作业',
  'aet.home.bulkEditSubtitle': '修改您的教学大纲后，在此重新上传。您的作业及截止日期将同步更新。',
  'aet.home.createAssignmentTitle': '创建作业',
  'aet.assignments.includedInAnotherAssignmentTooltip': '已包含在另一项作业中',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': '部分小节已包含在另一项作业中',
  'aet.welcome.welcome.Title': '欢迎！',
  'aet.home.student.roaster.ProgressTitle': '总完成度',
  'aet.assignmentStudentDetails.startAssignmentDescription': '学生开始作业后再来查看。',
  'aet.home.whatDueThisWeekTitle': '本周待完成作业',
  'aet.assignments.edit.errorTitle': '{count} 部分作业存在错误',
  'aet.assignments.edit.errorSubTitle': '存在错误的作业无法发布。请编辑修正错误，或选择跳过这些作业发布。',
  'aet.assignments.edit.publishAnyway': '仍要发布',
  'aet.assignments.edit.editAssignments': '编辑作业',
  'aet.assignments.edit.validationInfoToolTip': '编辑作业以修正错误',
  'aet.assignments.error.assignmentCreated.title': '所有作业均存在错误',
  'aet.assignments.error.assignmentCreated.description': '存在错误的作业无法发布。请编辑修正错误，或更换其他教学大纲重试。',
  'aet.assignments.error.uploadSyllabus': '上传教学大纲',
  'aet.assignments.error.editAssignments': '编辑作业',
  'aet.mondly.title': '语言',
  'aet.studentRoster.errorState.title': '学生名单无法获取',
  'aet.studentRoster.errorState.description': '我们无法加载您的学生名单。请尝试刷新或稍后再来查看。',
  'aet.assignments.sectionLabel': '章节',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': '题目',
  'aet.assignments.assignmentsLabel': '作业',
  'aet.assignments.performanceProgressBar': '成绩进度条',
  'aet.assignments.completionProgressBar': '完成进度条',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '您确定要删除这项作业吗？',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '您确定要删除这些作业吗？',
  'aet.home.nextAssignmentTitle': '下一项作业',
  'aet.home.courseSettings': '课程设置',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+电子教材资源',
  'aet.home.etextbookInformation': '电子教材信息',
  'aet.multiple.deleteAssignmentKeepCTA': '保留作业',
  'aet.syllabus.processingText.header': '我们正在整理您班级的指定阅读材料 – 此过程仅需片刻。',
  'aet.syllabus.processingText.uploading': '正在上传您的文件',
  'aet.syllabus.processingText.activating': '正在激活人工智能组件',
  'aet.syllabus.processingText.extracting': '正在提取阅读作业',
  'aet.syllabus.processingText.mapping': '正在映射教材内容',
  'aet.syllabus.processingText.finishing': '即将完成',
  'aet.syllabus.uploadErrorMessage': '请确保您的PDF或.docx格式文件大小不超过10MB，且网络连接稳定',
  'aet.syllabus.uploadNoAssignmentsMessage': '未找到阅读作业',
  'aet.syllabus.uploadNoAssignmentsDescription': '我们无法从该文件中提取阅读作业。您可手动添加。',
  'aet.syllabus.uploadFailedRetryCTA': '重试',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': '请再次确认教学大纲具备<qualities a syllabus should have for this to work>后重试，或切换至手动创建作业模式。',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': '手动创建',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': '出错了',
  'aet.syllabus.uploadModal.genericFailure.body1': '我们无法上传并处理该教学大纲。',
  'aet.syllabus.uploadModal.genericFailure.body2': '请检查网络连接后重试，或切换至手动创建作业模式。',
  'aet.syllabus.uploadModal.successTotal.title': '待核对',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': '待核对',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': '核对作业',
  'aet.syllabus.selectChapterWithQuestions': '请选择包含习题的章节。',
  'preferenceSetting.subTitle': '以上设置将作为本课程所有学生的默认设置。',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI互动功能',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': '启用AI学习工具及搜索结果AI总结功能',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': '显示与本教材相关的备考资源',
  'aet.syllabus.footer': '作业创建由AI提供支持',
  'aet.dashboard.footerDialogDeatils': '生成式AI根据培生学习资料创建作业题目。尽管培生设有内容审核流程，但生成式AI仍可能出现人物、地点或事实相关的错误信息。AI还会根据你提供的教学大纲和/或时间表，将内容整理成作业。',
  'aet.review.footer': '使用AI创建',
  'aet.footerCard.dismiss': '取消',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': '学习准备是一款辅助学习工具，为学生提供与本课程配套的视频和练习题。',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': '如果学生的访问计划中未包含学习准备，系统可能会要求其订阅该服务，以便继续使用学习准备的资源。',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': '已购买学习准备的学生不受此设置影响。',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': '了解学习准备的更多优势',
  'aet.home.viewCourseId': '查看课程ID',
  'aet.home.copy': '复制',
  'aet.home.copied': '已复制',
  'aet.home.courseLabel': '课程ID：',
  'schoolInfoCard.addUniversity': '添加学校',
  'schoolInfoCard.title': '学校信息',
  'schoolInfoCard.titleV1': '告诉我们您的课程',
  'schoolInfoCard.cta': '开始',
  'schoolInfoCard.pickInstitution': '选择学校',
  'schoolInfoCard.addUniversityTitle': '添加您的学校',
  'schoolInfoCard.addUniversitySubtitle': '了解你的学校和课程，有助于我们为你推荐最实用的学习资料。',
  'schoolInfoCard.searchPlaceholder': '搜索你的学校…',
  'schoolInfoCard.skip': '跳过此步骤',
  'schoolInfoCard.nextStep': '下一步',
  'schoolInfoCard.notInList': '我的学校不在列表中',
  'schoolInfoCard.noResults': '未找到与搜索匹配的学校',
  'schoolInfoCard.noResultsHeading': '找不到你的学校？',
  'schoolInfoCard.noResultsInstruction': '在下方输入完整名称',
  'schoolInfoCard.noResultsInputPlaceholder': '学校名称',
  'schoolInfoCard.addInstitutionLabel': '添加该学校',
  'aet.assignments.assignmentTitlePlaceholder': '输入标题',
  'aet.assignments.titleValidation.titleRequired': '作业标题为必填项。',
  'aet.assignments.titleValidation.titleTooLong': '作业标题长度不得超过{0}个字符。',
  'aet.assignments.titleValidation.titleInvalidChar': '作业标题包含不支持的字符。',
  'aet.assignments.titleValidation.titleDuplicate': '作业标题已存在',
  'aet.syllabus.timeZoneLabel': '时区',
  'aet.review.reviewReadingFromAssignments': '复习作业中的阅读内容',
  'aet.assignments.chaptersLabel': '章节',
  'menu.myAccount.subTitle': '此处展示您的所属机构',
  'menu.myAccount.subTitleNotAvailable': '您可随时在此添加所属机构。',
  'schoolInfoCard.toastMessage': '大学已保存',
  'aet.review.threeDotMenu.askAI': '询问AI',
  'aet.home.suggestedRemediationSubtitle': '观看相关视频并练习，掌握课程内容。',
  'aet.home.laggedQuestionLabel': '已标记题目',
  'aet.home.correctAnswer': '正确答案',
  'aet.home.incorrectAnswer': '最常见错误答案',
  'aet.home.behaviourTrendsLabel': '题目解析',
  'aet.home.strugglingStudentsLabel': '学习有困难的学生',
  'aet.home.patternsInStudensAiLabel': '学生使用AI的行为模式',
  'aet.home.questionLabel': '问题',
  'aet.home.studentAskingSimilarQuestions': '提出相似问题的学生',
  'aet.home.assignmentDifficultQuestions': '难题',
  'aet.home.behaviorTrends': '题目解析',
  'aet.home.behaviors': '学业表现指标',
  'aet.home.mostDifficultTopics': '最高难度题目',
  'aet.home.commentsFromStudentLabel': '学生意见',
  'aet.home.disregard': '忽略',
  'aet.home.reportAsInaccurate': '举报为不准确内容',
  'aet.home.Flagged': '已标记',
  'aet.home.reportQuestionTitle': '报告题目',
  'aet.home.reportQuestionLabel': '本题存在什么问题？',
  'aet.home.showComments': '显示评论',
  'aet.home.studentReports': '学生报告',
  'aet.home.placeholderText': '请说明......',
  'aet.home.reportQuestion.notRelevant': '不相关',
  'aet.home.reportQuestion.notCorrect': '不正确',
  'aet.home.reportQuestion.unsafe': '不安全/有害',
  'aet.home.reportQuestion.somethingElse': '其他',
  'aet.home.StudentDetails.assistedByAI': 'AI辅助完成',
  'aet.home.strugglingStudents.emptyStateTitle': '目前无学生存在学习困难',
  'aet.home.strugglingStudents.emptyStateDescription': '稍后再来查看。',
  'aet.home.overallStatus.excelling': '表现优秀',
  'aet.home.overallStatus.fallingBehind': '进度落后',
  'aet.home.overallStatus.keepingUp': '进度正常',
  'aet.home.showOnlyDifficultQuestionsLabel': '仅显示“难题”',
  'aet.home.showOnlyStrugglingStudentsLabel': '仅显示“学习困难学生”',
  'aet.home.viewQuestionInAssignment': '查看作业中的题目',
  'aet.home.insightRisk.incorrectFirstAttempts': '首次作答错误',
  'aet.home.insightRisk.multipleIncorrectAttempts': '多次作答错误',
  'aet.home.insightRisk.lowConfidence': '信心偏低',
  'aet.home.insightRisk.mediumConfidence': '信心中等',
  'aet.home.insightRisk.lowEngagement': '参与度偏低',
  'aet.home.insightRisk.countOfStudents': '{count} / {total}学生',
  'aet.home.insightRisk.na': '不适用',
  'aet.home.strugglingStudentsHereLabel': '该部分学生学习困难',
  'aet.home.insightRisk.didNotAttempt': '未作答',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS集成',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default zhcn;
